<!-- Целиком кликабельная карточка интеграции для каталога на desktop и mobile. -->
<template>
  <BaseNavigationCard
    layout="catalog"
    color="gray"
    :label="card.title"
    :description="card.description"
    :eyebrow="card.category"
    :icon-text="card.icon"
    :mobile-status-hidden="card.connected && !card.loadFailed"
    @click="openIntegration"
  >
    <template #status>
      <BaseBadge
        class="integration-catalog-card__status"
        :class="{
          'integration-catalog-card__status--connected':
            card.connected && !card.loadFailed,
        }"
        :label="statusLabel"
        :variant="statusVariant"
      />
    </template>

    <template #footer>
      <span
        class="integration-catalog-card__fact"
        :class="{
          'integration-catalog-card__fact--action':
            card.available &&
            !card.connected &&
            !card.loadFailed,
        }"
      >
        {{ factText }}
      </span>
    </template>
  </BaseNavigationCard>
</template>

<script>
export default {
  name: "IntegrationCatalogCard",

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusLabel() {
      if (this.card.loadFailed) return "Не удалось загрузить";
      if (!this.card.available) return "Скоро";
      return this.card.connected ? "Подключено" : "Не подключено";
    },

    statusVariant() {
      if (this.card.loadFailed) return "danger";
      if (!this.card.available) return "info";
      return this.card.connected ? "success" : "default";
    },

    factText() {
      return this.card.loadFailed ? "Открыть" : this.card.fact;
    },
  },

  methods: {
    openIntegration() {
      this.$router.push(this.card.route);
    },
  },
};
</script>

<style scoped>
.integration-catalog-card__fact {
  color: inherit;
}

.integration-catalog-card__status {
  white-space: nowrap;
}

.integration-catalog-card__fact--action {
  color: var(--color-green-hover);
}

</style>
